import React, { useState } from "react";
import { Socket } from "socket.io-client";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import INotification from "../../../models/INotification";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import Moment from "moment";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    cancelFn: (refreshData?: boolean) => void;
    startFn: (startDate: string, endDate?: string, docNumber?: string) => void;
    hasDefaultPriceGroup: boolean;
};

export const QboPullInvoicesAsOrdersModal = (props: Props) => {
    const [selectedStartDate, setSelectedStartDate] = useState<Moment.Moment | null | undefined>();
    const [selectedEndDate, setSelectedEndDate] = useState<Moment.Moment | null | undefined>();
    const [docNumber, setDocNumber] = useState<string>("");

    const start = () => {
        if (selectedStartDate && props.hasDefaultPriceGroup) {
            props.startFn(
                selectedStartDate.format("YYYY-MM-DD"),
                selectedEndDate ? selectedEndDate.format("YYYY-MM-DD") : undefined,
                docNumber.trim() ? docNumber.trim() : undefined
            );
            props.cancelFn(false);
        }
    };

    return (
        <div className={"QboPullInvoicesAsOrdersModal p-3"} style={{ maxWidth: "40vw", width: "100%", margin: "0 auto" }}>
            <div className={"d-flex justify-content-between"}>
                <OwTitle tag={"h4"} title={"QuickBooks Online Pull Invoices"} disableTranslation={true} />
                <div>
                    <OwButton
                        className={"btn-danger"}
                        centerIconClass={"fas fa-times"}
                        fn={() => {
                            props.cancelFn(false);
                        }}
                    />
                </div>
            </div>
            {!props.hasDefaultPriceGroup && (
                <div className={"alert alert-warning mt-2 mb-0"}>
                    <strong>Default Price Group required</strong> - You must select a Default Price Group on your QuickBooks Online
                    integration before you can pull invoices as orders.
                </div>
            )}
            <div className={"row"}>
                <div className={"col-12 col-md-6 mt-2"}>
                    <div className={"d-flex align-items-center"}>
                        <OwTitle tag={"h6"} title={"start_date"} defaultMargins={false} />
                        <span className={"text-danger ms-1"}>*</span>
                    </div>
                    <OwDateInput
                        selectedDate={selectedStartDate}
                        fn={(date) => {
                            setSelectedStartDate(date);
                        }}
                    />
                </div>
                <div className={"col-12 col-md-6 mt-2"}>
                    <div className={"d-flex align-items-center"}>
                        <OwTitle tag={"h6"} title={"end_date"} defaultMargins={false} />
                    </div>
                    <OwDateInput
                        selectedDate={selectedEndDate}
                        fn={(date) => {
                            setSelectedEndDate(date);
                        }}
                    />
                </div>
            </div>
            <div className={"mt-2"}>
                <OwTitle tag={"h6"} title={"Doc. Number"} disableTranslation={true} />
                <OwFnInput
                    name={"docNumber"}
                    value={docNumber}
                    placeholder={"Doc. Number"}
                    skipTranslate={true}
                    fn={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setDocNumber(e.target.value);
                    }}
                />
            </div>
            <div className={"mt-2"}>
                <OwButton title={"start"} fn={start} disabled={!selectedStartDate || !props.hasDefaultPriceGroup} />
            </div>
        </div>
    );
};
